import "./ImmigrationAndRegularizationServices.module.css";
import Header from "@/reusable_sections/Header";
import ServicesOverview from "./sections/ServicesOverview";
import Footer from "@/reusable_sections/Footer";
export default function ImmigrationAndRegularizationServicesPage() {
  return <div>
      <Header />
      <ServicesOverview />
      <Footer />
    </div>;
}